// extracted by mini-css-extract-plugin
module.exports = {"bannercontainer":"BannerDownloadTheApp_bannercontainer__P0bH_","slogan":"BannerDownloadTheApp_slogan__pUoU7","anchor":"BannerDownloadTheApp_anchor__igJ3H"};